import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

const ConfigContext = createContext<Record<string, string>>({});

export const useConfig = (): Record<string, string> => {
    const context = useContext(ConfigContext);
    if (context === undefined) {
        throw new Error('No Provider for ConfigContext is found in a parent component');
    }

    return context;
};

interface ConfigProviderProps {
    config: Record<string, string>;
    children: ReactNode;
}

export const ConfigProvider = ({ config, children }: ConfigProviderProps) => (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
);
